export const slugify = (value = '') => {
  return value
    .toString()
    .trim()
    .toLowerCase()
  .replace(/[^a-z0-9\s-]/g, '')
  .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
};

export const slugifyWithFallback = (value, fallback) => {
  const slug = slugify(value);
  if (slug) {
    return slug;
  }
  return fallback;
};

export default slugify;
